import { Component, inject } from '@angular/core';
import { NavigationCancel, NavigationError, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { LoaderService } from './shared/services/loader.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, LoaderComponent],
    templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'Misión Empresarial';

  private readonly router = inject(Router);
  private readonly loader = inject(LoaderService);

  constructor() {
    // Una navegación que falla o se cancela deja al usuario donde estaba, y si venía con
    // el loader arriba (login: "Cargando información del usuario...") la pantalla quedaba
    // bloqueada sin explicación. Se libera el overlay y el fallo queda en consola.
    this.router.events
      .pipe(filter((e): e is NavigationError | NavigationCancel => e instanceof NavigationError || e instanceof NavigationCancel))
      .subscribe((e) => {
        console.error('[Router] Navegación no completada:', e);
        this.loader.hide();
      });
  }
}
